import React from "react";
import { Link } from "gatsby";

const DropdownMenuLink = ({ to, label, dropdownMenuItems }) => {
  return (
    <li className="menu-link-list-item">
      <LinkWrapper to={to} className="menu-link" activeClassName="active">
        {label}
      </LinkWrapper>
      <div className="dropdown-menu">
        <ul>
          {dropdownMenuItems.map(({ dropdownTo, dropdownLabel }) => {
            return (
              <li key={dropdownLabel}>
                <LinkWrapper to={dropdownTo}>{dropdownLabel}</LinkWrapper>
              </li>
            );
          })}
        </ul>
      </div>
    </li>
  );
};

export function LinkWrapper({ to, children, className, activeClassName }) {
  if (to[0] === "/") {
    return (
      <Link className={className} to={to} activeClassName={activeClassName}>
        {children}
      </Link>
    );
  }

  return (
    <a
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
    </a>
  );
}

export default DropdownMenuLink;
